import { FiLayout, FiSmartphone, FiTrendingUp, FiShare2, FiBox, FiTarget, FiCode, FiPenTool } from "react-icons/fi";

export const servicesData = [
    {
        id: "influencer marketing",
        title: "Influencer Marketing",
        desc: "We craft powerful, result driven influencer marketing campaigns that build trust, amplify your brand voice and drive real conversions. Our strategies connect your brand with the right creators to turn influence into measurable growth.",
        icon: <FiLayout />,
        image: "/images/homeServicesImages/Influencer-Marketing.webp",
        subServices: [
            {
                name: "Influencer Identification and Vetting",
                description: "We analyze audience demographics, engagement rates, and niche relevance to select the right creators."
            },
            {
                name: "Campaign Strategy Development",
                description: "We design structured influencer campaigns aligned with brand goals and audience expectations."
            },
            {
                name: "Content Collaboration and Direction",
                description: "We ensure brand messaging integrates naturally into influencer content."
            },
            {
                name: "Campaign Management",
                description: "We manage communication, timelines, approvals, and execution for seamless collaboration."
            },
            {
                name: "Performance Tracking and ROI Measurement",
                description: "We monitor engagement, reach, and conversions to measure campaign effectiveness."
            }
        ],
        fullDescription: "Influencer marketing builds trust through authentic digital voices. We connect your brand with relevant creators to expand reach, increase engagement, and drive meaningful conversions through strategic partnerships.",
        cta: {
            badge: "Partner With Creators",
            heading: "READY TO PARTNER WITH",
            headingAccent: "THE RIGHT INFLUENCERS?",
            description: "Get a free influencer strategy review and discover how creator partnerships can grow your brand.",
            buttonText: "Get Free Influencer Audit"
        }
    },
    {
        id: "performance marketing",
        title: "Performance Marketing",
        desc: "We build high converting performance marketing campaigns designed to accelerate growth, increase customer acquisition and deliver measurable returns. Our approach combines precision targeting, compelling creatives and continuous optimization to turn every click into real business impact",
        icon: <FiSmartphone />,
        image: "/images/homeServicesImages/Perfomance-marketing.webp",
        subServices: [
            {
                name: "Paid Search Advertising",
                description: "We create and manage high intent search campaigns that target customers actively looking for your products or services, driving qualified traffic that converts."
            },
            {
                name: "Paid Social Media Campaigns",
                description: "Our targeted advertising across platforms like Meta, LinkedIn, and TikTok increases brand visibility while driving measurable engagement and sales."
            },
            {
                name: "Conversion Rate Optimization",
                description: "We optimize landing pages and sales funnels through testing and behavioral analysis to increase conversions and improve campaign efficiency."
            },
            {
                name: "Retargeting and Funnel Strategy",
                description: "We re engage previous visitors and guide them through structured funnels to maximize customer lifetime value."
            },
            {
                name: "Analytics and Performance Tracking",
                description: "We continuously monitor performance metrics, optimize campaigns in real time, and provide transparent reporting focused on growth."
            }
        ],
        fullDescription: "Performance marketing is built on measurable growth. At Xpin Media, we create data driven paid advertising strategies designed to increase qualified leads, lower acquisition costs, and maximize return on investment. Every campaign is optimized for results, ensuring your brand scales efficiently and profitably.",
        cta: {
            badge: "Maximize Your ROI",
            heading: "NOT SEEING THE",
            headingAccent: "ROI YOU SHOULD?",
            description: "Get a free audit of your current campaigns and discover how to scale efficiently.",
            buttonText: "Get Free Performance Audit"
        }
    },
    {
        id: "social media management",
        title: "Social Media Management",
        desc: "We create strategic & engagement focused social media experiences that strengthen brand presence and build meaningful audience connections. Our approach blends creative storytelling with data insights to grow your community and turn followers into loyal customers.",
        icon: <FiTrendingUp />,
        image: "/images/homeServicesImages/smm.webp",
        subServices: [
            {
                name: "Content Strategy and Planning",
                description: "We create structured content calendars aligned with your brand voice and audience behavior."
            },
            {
                name: "Creative Content Production",
                description: "From static posts to short form videos, we produce engaging visuals that capture attention and encourage interaction."
            },
            {
                name: "Community Management",
                description: "We actively manage audience engagement, respond to interactions, and build meaningful brand conversations."
            },
            {
                name: "Paid Social Amplification",
                description: "We enhance organic content with targeted paid campaigns to increase reach and drive conversions."
            },
            {
                name: "Growth and Analytics Reporting",
                description: "We track engagement, audience growth, and performance metrics to continuously refine strategy."
            }
        ],
        fullDescription: "Social media is where brands build relationships and influence buying decisions. We develop strategic social media management solutions that strengthen brand presence, increase engagement, and turn followers into loyal customers.",
        cta: {
            badge: "Amplify Your Brand",
            heading: "IS YOUR SOCIAL MEDIA",
            headingAccent: "DRIVING REAL GROWTH?",
            description: "Get a free social media strategy audit and learn how to turn followers into customers.",
            buttonText: "Get Free Social Media Audit"
        }
    },
    {
        id: "search engine optimization",
        title: "Search Engine Optimization",
        desc: "We deliver result oriented SEO strategies that improve search rankings, increase organic traffic and strengthen your digital authority. Our optimization techniques ensure your brand gets discovered by the right audience at the right time.",
        icon: <FiShare2 />,
        image: "/images/homeServicesImages/SEO.webp",
        subServices: [
            {
                name: "Keyword Research and Strategy",
                description: "We identify high value search terms that align with user intent and business goals."
            },
            {
                name: "On Page Optimization",
                description: "We optimize website content, structure, and metadata to improve search engine visibility."
            },
            {
                name: "Technical SEO Improvements",
                description: "We enhance website speed, mobile performance, crawlability, and indexing for stronger rankings."
            },
            {
                name: "Link Building and Authority Growth",
                description: "We build high quality backlinks to strengthen domain authority and competitive positioning."
            },
            {
                name: "Performance Monitoring and Reporting",
                description: "We track keyword rankings, organic traffic, and conversion data for measurable SEO growth."
            }
        ],
        fullDescription: "Search engine optimization builds long term visibility and sustainable growth. Our SEO strategies improve search rankings, increase organic traffic, and position your brand in front of high intent users actively searching for your services.",
        cta: {
            badge: "Rank Higher",
            heading: "STRUGGLING TO RANK",
            headingAccent: "ON SEARCH ENGINES?",
            description: "Claim your free SEO audit and uncover opportunities to increase traffic and visibility.",
            buttonText: "Get Free SEO Audit"
        }
    },
    {
        id: "photography videography",
        title: "Photography & Videography",
        desc: "We create visually compelling photography and cinematic video content that captures your brand's essence and leaves a lasting impression. Our creative productions are designed to elevate brand identity, enhance engagement and drive powerful storytelling across digital platforms.",
        icon: <FiBox />,
        image: "/images/homeServicesImages/Videograpghy-&-Photography.webp",
        subServices: [
            {
                name: "Product Photography",
                description: "High quality product visuals optimized for ecommerce and promotional campaigns."
            },
            {
                name: "Corporate and Brand Shoots",
                description: "Professional imagery that enhances credibility and brand presentation."
            },
            {
                name: "Promotional Video Production",
                description: "Engaging video content designed for ads, websites, and social platforms."
            },
            {
                name: "Event Coverage",
                description: "High definition photography and videography capturing important brand moments."
            },
            {
                name: "Social Media Visual Content",
                description: "Short form videos and creative visuals tailored for engagement driven platforms."
            }
        ],
        fullDescription: "Visual storytelling defines brand perception. Our professional photography and videography services create impactful visual content that elevates brand identity and strengthens digital marketing performance.",
        cta: {
            badge: "Capture Your Vision",
            heading: "READY TO ELEVATE",
            headingAccent: "YOUR VISUAL IDENTITY?",
            description: "Book a free creative consultation and discover how powerful visuals can transform your brand presence.",
            buttonText: "Get Free Creative Consultation"
        }
    },
    {
        id: "brand strategy",
        title: "Brand Strategy",
        desc: "We build powerful brand strategies that define your identity, clarify your message, and position your business for long term growth. Our strategic approach aligns vision, voice, and visuals to create a strong market presence that stands out and connects with the right audience",
        icon: <FiTarget />,
        image: "/images/homeServicesImages/Brand-Strategy.webp",
        subServices: [
            {
                name: "Brand Positioning",
                description: "We define your unique value proposition and market differentiation strategy."
            },
            {
                name: "Market and Competitor Research",
                description: "We analyze industry trends and competitors to identify growth opportunities."
            },
            {
                name: "Brand Messaging Framework",
                description: "We develop your brand voice, story, and communication structure."
            },
            {
                name: "Visual Identity Direction",
                description: "We provide strategic guidance for logo, typography, and visual systems."
            },
            {
                name: "Brand Guidelines Development",
                description: "We create comprehensive documentation to ensure brand consistency across platforms."
            }
        ],
        fullDescription: "A strong brand strategy defines your identity, positioning, and long term direction. We help businesses build clear, compelling brand foundations that differentiate them in competitive markets and create lasting impact.",
        cta: {
            badge: "Define Your Legacy",
            heading: "READY TO BUILD A",
            headingAccent: "BRAND THAT LEADS?",
            description: "Get a free brand strategy consultation and discover how to position your business for long term growth.",
            buttonText: "Get Free Brand Consultation"
        }
    },
    {
        id: "web development",
        title: "Web Development",
        desc: "We build high performance, scalable websites that combine cutting edge technology with seamless user experience. Our web development solutions are designed to strengthen your digital presence, enhance functionality and drive measurable business growth.",
        icon: <FiCode />,
        image: "/images/homeServicesImages/website-development.webp",
        subServices: [
            {
                name: "Custom Website Development",
                description: "We develop tailored websites aligned with your brand and business objectives."
            },
            {
                name: "E Commerce Development",
                description: "We create secure and optimized online stores designed for seamless purchasing experiences."
            },
            {
                name: "Responsive and Mobile Optimization",
                description: "We ensure flawless performance across all devices and screen sizes."
            },
            {
                name: "Performance and Speed Optimization",
                description: "We enhance loading speed and technical performance to improve user experience and SEO."
            },
            {
                name: "Website Maintenance and Support",
                description: "We provide ongoing updates, monitoring, and technical support for long term stability."
            }
        ],
        fullDescription: "Your website is the foundation of your digital presence. We build high performance, responsive, and scalable websites designed to enhance user experience, strengthen credibility, and drive conversions.",
        cta: {
            badge: "Digital Excellence",
            heading: "IS YOUR WEBSITE",
            headingAccent: "COSTING YOU CUSTOMERS?",
            description: "Request a free website audit and discover how to improve speed, usability, and conversions.",
            buttonText: "Get Free Website Audit"
        }
    },
    {
        id: "graphics designing",
        title: "Graphics Designing",
        desc: "We craft visually powerful graphic design solutions that communicate your brand story with clarity and creativity. From brand identities to marketing collateral, our designs are built to captivate audiences, strengthen brand recognition and make a lasting visual impact.",
        icon: <FiPenTool />,
        image: "/images/homeServicesImages/Graphic-Design.webp",
        subServices: [
            {
                name: "Logo and Brand Identity Design",
                description: "We create distinctive logos and identity systems that define your brand's visual character."
            },
            {
                name: "Social Media Graphics",
                description: "We design scroll-stopping visuals tailored for every platform to boost engagement and brand consistency."
            },
            {
                name: "Marketing Collateral Design",
                description: "We produce brochures, flyers, banners and print materials that reinforce your brand message."
            },
            {
                name: "Packaging Design",
                description: "We design product packaging that stands out on shelves and aligns with your brand identity."
            },
            {
                name: "Presentation and Pitch Deck Design",
                description: "We create visually compelling decks that communicate ideas clearly and professionally."
            }
        ],
        fullDescription: "Design is the first impression your brand makes. Our graphic design services create visually compelling, strategically crafted assets that elevate brand presence, strengthen recognition, and communicate your message with impact across every platform and touchpoint.",
        cta: {
            badge: "Design That Converts",
            heading: "READY TO MAKE YOUR",
            headingAccent: "BRAND UNFORGETTABLE?",
            description: "Get a free design consultation and discover how powerful visuals can transform your brand identity.",
            buttonText: "Get Free Design Consultation"
        }
    }
];

// Helper function to get service by ID
export const getServiceById = (id) => {
    return servicesData.find(service => service.id === id);
};

// Helper function to get all service IDs
export const getAllServiceIds = () => {
    return servicesData.map(service => service.id);
};
